import { defaultFretAmount } from "../constants";

export default class Fretboard {
	title = "";
	instrument = "guitar";
	strings = null;
	dots = null;
	frets = defaultFretAmount;

	constructor(title, instrument, strings, dots, frets = defaultFretAmount) {
		this.title = title;
		this.instrument = instrument;
		this.strings = strings;
		this.dots = dots;
		this.frets = frets;
	}
}
